import styled from 'styled-components'

import Container from '../container'
import {
  MetaInformation,
  MetaInformationContainer,
} from '../organisms/heroCarousel'
import theme from './theme'

export const MobileOnly = styled.div`
  @media only screen and ${theme.breakpoints.fromNormalScreen} {
    display: none;
  }
`

export const DesktopOnly = styled.div`
  @media only screen and ${theme.breakpoints.toNormalScreen} {
    display: none;
  }
`

import { H1 } from '../Typography/Typography'

const { breakpoints, colours, font, animation } = theme

const heroHeight = '50'

export const MetaContainer = styled(Container)`
  padding-top: 3.4rem;
  margin-bottom: 3.4rem;
`

export const Breadcrumbs = styled.div`
  font-size: 1.2rem;
  text-transform: uppercase;
  font-weight: ${font.fontWeightBold};
  margin-bottom: 1rem;

  a {
    text-decoration: none;
    color: ${colours.primary};
  }
`

export const H1Styled = styled(H1)`
  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: 3.6rem;
  }
`

export const Left = styled.div`
  flex-basis: 50%;
`

export const Right = styled.div`
  flex-basis: 50%;

  @media only screen and ${breakpoints.fromNormalScreen} {
    margin-left: 4rem;
  }
`

export const MetaContainerWrapper = styled.div`
  display: flex;

  @media only screen and ${breakpoints.toNormalScreen} {
    flex-direction: column;
  }
`

export const HeroImage = styled.div`
  height: 40vh;
  overflow: hidden;
  position: relative;

  @media only screen and ${breakpoints.fromNormalScreen} {
    height: ${heroHeight}vh;
  }
`

export const ExtraMeta = styled.div`
  @media only screen and ${breakpoints.fromNormalScreen} {
    margin-top: -5.5rem;
    margin-bottom: 3.6rem;
  }
`

export const ContentWrapper = styled.div`
  background-color: ${colours.lightTint4};
  padding-bottom: 3.6rem;
`

export const ContentContainer = styled(Container)`
  display: flex;

  @media only screen and ${breakpoints.toNormalScreen} {
    flex-direction: column;
    padding: 0;
  }

  @media only screen and ${breakpoints.fromNormalScreen} {
    align-items: flex-start;
  }
`

export const ContentBodyContainer = styled.div`
  flex-grow: 1;

  @media only screen and ${breakpoints.fromNormalScreen} {
    width: 75%;
  }
`

export const ContentBody = styled.div`
  background-color: ${colours.light};
  padding: 2rem;

  @media only screen and ${breakpoints.fromNormalScreen} {
    margin-right: 3.4rem;
    padding: 3.8rem 4rem;
  }

  p {
    margin-top: 0;
  }

  a {
    line-break: anywhere;
  }
`

export const SidebarWrapper = styled.div`
  @media only screen and ${breakpoints.fromNormalScreen} {
    width: 25%;
  }
`

export const Sidebar = styled.div`
  background-color: ${colours.dark};
  color: ${colours.light};
  padding: 2rem;
`

export const StyledLink = styled.a`
  text-decoration: none;
`

export const SidebarContentContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SidebarContent = styled.div`
  h4 {
    margin-bottom: 0.5rem;
  }

  p {
    margin-top: 0;
  }

  a {
    transition: color ${animation.defaultLength} ease-in-out;
  }

  a:hover {
    color: ${colours.primary};
  }
`

export const SidebarContentIcon = styled.div`
  margin-top: 0.2rem;
  margin-right: 1.6rem;
`

export const PriceContainer = styled.div`
  background-color: ${colours.primary};
  flex-basis: 25%;
  color: ${colours.light};
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1.6rem;
  text-decoration: none;
  transition: background-color ${animation.defaultLength} ease-in-out;
  text-align: center;

  &:not(div):hover {
    background-color: ${colours.primaryTint1};
  }

  p {
    margin: 0;
  }
`

export const PassedPriceContainer = styled.div`
  background-color: ${colours.secondary};
  flex-basis: 25%;
  color: ${colours.light};
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1.6rem;
  text-decoration: none;
  transition: background-color ${animation.defaultLength} ease-in-out;
  text-align: center;

  &:not(div):hover {
    background-color: ${colours.primaryTint1};
  }

  p {
    margin: 0;
  }
`

export const StyledMetaInformation = styled(MetaInformation)`
  position: relative;
  flex-basis: ${(props): string | null => (props.fullWidth ? '100%' : '75%')};

  @media only screen and ${breakpoints.toNormalScreen} {
    padding: 0;
  }

  @media only screen and ${breakpoints.fromNormalScreen} {
    padding-right: 2.4rem;
  }
`

export const StyledMetaInformationContainer = styled(MetaInformationContainer)`
  display: flex;
  flex-direction: column-reverse;

  @media only screen and ${breakpoints.fromNormalScreen} {
    flex-direction: row;
  }
`
